export default __webpack_public_path__ + "static/media/gallery3.2f45a6e8.jpg";